import React from 'react';

const GetCurious = () => (
  <section id="four" className="main style1 special sub-header-icons">
    <div className="grid-wrapper">
      <div className="col-4">
        {/* <span className="icon major fas fa-user-cog orange"></span> */}
        <h3>Get Curious</h3>
      </div>
      <div className="col-4">
        {/* <span className="icon major fas fa-drafting-compass orange"></span> */}
        <h3>Get Clear</h3>
      </div>
      <div className="col-4">
        {/* <span className="icon major fa-save orange"></span> */}
        <h3>Get Committed</h3>
      </div>
    </div>
  </section>
);

export default GetCurious;